// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","zGreen":"#BFD730","header":"_36Ya","content":"_3pcW","contentCol":"_3GX7","share":"_3Llr","center":"fKvN"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Blog/BlogArticle/BlogArticle.scss
// module id = Gxv7
// module chunks = 0